import angular from 'angular';
import { PriceConfigurationPanel } from '@alquilatucancha/backoffice-integration';

const moduleName = 'atc-price-modifiers';

angular.module(moduleName, []).directive('priceModifiers', [
    'Backoffice',
    (Backoffice) => ({
        restrict: 'A',
        scope: {
            courtId: '@',
        },
        link: (_scope, el) => {
            Backoffice.renderComponent(el[0], PriceConfigurationPanel, {
                court_id: _scope.courtId,
            });

            // Al destruirse, desmontar el root de React (evita fugas en body).
            _scope.$on('$destroy', () => {
                Backoffice.unmountComponent?.(el[0]);
            });
        },
    }),
]);

export default moduleName;
